const DEFAULT_STATE = {
    product: {
        variantName: null,
        variantSystemId: null,
        imageUrl: null,
        variantId: null
    }
};

export const currentProduct = (state = DEFAULT_STATE, action) => { 
    switch (action.type) {
        default:
            return state;
    }
};
